import { useCallback, useState } from 'react';

interface MenuOpenedStateReturn {
  menuOpened: boolean;
  handleMenuOpen: () => void;
  handleMenuClose: () => void;
}

/**
 * Hook that manages menu open/close state
 * @returns Object containing menu state and handlers
 */
export const useMenuOpenedState = (): MenuOpenedStateReturn => {
  const [menuOpened, setMenuOpened] = useState<boolean>(false);

  const handleMenuOpen = useCallback((): void => {
    setMenuOpened(true);
  }, []);

  const handleMenuClose = useCallback((): void => {
    setMenuOpened(false);
  }, []);

  return {
    menuOpened,
    handleMenuOpen,
    handleMenuClose,
  };
};
